import { combineReducers } from 'redux';
import preferences from './preferences/preferences.reducer';

const reducers = combineReducers({
    preferences,
});

export default reducers;
